import {createContext} from 'react';

export type AddTableTicketContextType = {
	activeStep: number;
	onCloseModal?: () => void;
	handleBackStep?: () => void;
};

export const AddTableTicketContext = createContext({} as AddTableTicketContextType);
